import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
// import { OutputData } from '@editorjs/editorjs';

import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { v4 as uuidv4 } from 'uuid';
import { Channel } from '../../../../models/channel.model';
import { ArticleService } from '../../../../services/article.service';
import { AuthService } from '../../../../services/auth.service';
import * as articleActions from '../../../../state/actions/article.actions';
import { AppState } from '../../../../state/appstate';
import { LoadingDotsComponent } from '../../../components/spinners/loading-dots/loading-dots.component';
import { TextEditorComponent } from '../../../components/text-editor/text-editor.component';

@Component({
  selector: 'app-create-article',
  standalone: true,
  templateUrl: './create-article.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoadingDotsComponent,
    MatStepperModule,
    CdkStepperModule,
    TextEditorComponent,
  ],
  styleUrls: ['./create-article.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateArticleComponent {
  @ViewChild('stepper') private stepper!: MatStepper;
  @ViewChild('textEditor', { static: false }) textEditor!: TextEditorComponent;

  pageForm: FormGroup;
  tags: Array<string> = [];

  channelSub: Subscription | undefined;
  channel: Channel | null = null;

  articleStateSub: Subscription | undefined;

  working: boolean = false;
  fileUploaded: boolean = false;

  progress: number = 0;
  message: string = '';

  // initialData: any = {
  //   blocks: [
  //     {
  //       type: 'header',
  //       data: {
  //         text: "Let's write an awesome article!",
  //         level: 2,
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       data: { text: 'Note:' },
  //     },
  //     {
  //       type: 'list',
  //       data: {
  //         items: [
  //           'Your articles will be read on hand-held devices, so keep them short.',
  //           'Use headings and bullet points to make your article easy to read.',
  //         ],
  //       },
  //     },
  //   ],
  // };

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private articleService: ArticleService,
    private auth: AuthService,
    private fbAuth: Auth,
    private toastr: ToastrService
  ) {
    this.pageForm = this.fb.group({
      title: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(200),
      ]),
      description: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(500),
      ]),
      tagField: new FormControl(),
    });

    this.channelSub = this.store
      .select((state) => state.channel.channel)
      .subscribe((channel) => {
        this.channel = channel;
      });
    this.articleStateSub = this.store
      .select((state) => state.articles)
      .subscribe((articles) => {
        this.working = articles.inProgress;
      });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.channelSub?.unsubscribe();
    this.articleStateSub?.unsubscribe();
  }

  addTag() {
    this.pageForm.get('tagField')?.setErrors(null);
    if (this.pageForm.get('tagField')?.value === null) return;
    const fieldValue: string = this.pageForm.get('tagField')?.value.trim();
    if (fieldValue === '') return;
    if (fieldValue.includes(' '))
      return this.pageForm.controls['tagField'].setErrors({
        invalidValue: true,
      });
    if ((this.tags.length ?? 0) >= 10)
      return this.pageForm.controls['tagField'].setErrors({
        maxValuesAllowed: true,
      });
    this.tags = [...this.tags, fieldValue];
    this.pageForm.get('tagField')?.setValue('');
    this.pageForm.get('tagField')?.markAsPristine();
  }

  removeTag(tag: number) {
    this.tags.splice(tag, 1);
  }

  // async loadArticle(event: any) {
  //   const file: File = event.target.files[0];
  //   const uploadFileName = file.name;
  //   const uploadFileContent: any = await file.text();
  //   this.textEditor.loadData(JSON.parse(uploadFileContent) as OutputData);
  // }

  // saveArticle() {
  //   this.textEditor.data().then((data) => {
  //     var fileName = `article-${moment().format('DDMMYYhhmmss')}.txt`;
  //     var a = document.createElement('a');
  //     var myFile = new Blob([JSON.stringify(data)], { type: 'text/plain' });
  //     a.href = URL.createObjectURL(myFile);
  //     a.download = fileName;
  //     a.click();
  //   });
  // }

  async createArticle(): Promise<void> {
    if (this.pageForm.invalid) return;

    this.working = true;

    try {
      // Article id for S3 and DynamoDB
      const uuid: string = uuidv4();

      // call two promises and wait for them to complete
      // const [response, articleData] = await Promise.all([
      //   await this.articleService.getUploadUrl(uuid),
      // await this.textEditor.data(),
      // ]);

      // Call AWS SignedUrl to upload the article
      // await this.articleService
      //   .uploadArticle(response.url, articleData)
      //   .then((response) => {
      //     return this.store.dispatch(
      //       articleActions.create({
      //         article: {
      //           id: uuid,
      //           title: this.pageForm.controls['title'].value.trim(),
      //           description: this.pageForm.controls['description'].value.trim(),
      //           tags: this.tags,
      //           channelName: this.channel?.name!,
      //           channelId: this.channel?.id!,
      //           channelImageUrl: this.channel?.imageUrl!,
      //           createdBy: this.channel?.createdBy!,
      //         } as Partial<Article>,
      //       })
      //     );
      //   })
      //   .catch((error: any) => {
      //     this.toastr.error(
      //       `An error occurred while uploading the articles. Please try again later.`,
      //       'Error Creating Article'
      //     );
      //     this.store.dispatch(
      //       articleActions.createFailure({
      //         error: `An error occurred, '${error.message}'. Please try again later.`,
      //       })
      //     );
      //   });
    } catch (error) {
      this.toastr.error(
        `An error occurred during article creation. Please try again later.`,
        'Error Creating Article'
      );
      this.store.dispatch(
        articleActions.createFailure({
          error: `An error occurred, '${error}'. Please try again later.`,
        })
      );
    }
  }

  get formArray(): AbstractControl {
    return this.pageForm.get('steps')!;
  }
}
